import React from "react";
import { Field } from "formik";
import { currentLocale } from "../locale";
import { validateEmail } from "./validation";
import CustomIntlTelInput from "./CustomIntlTelInput";
import { Checkbox } from "./Checkbox";
import AddressInput from "./AddressInput";

const ContactInfoFields = ({
    waiver,
    errors,
    touched,
    values,
    preferredCountries,
}) => {
    return (
        <>
            {waiver.getEmail && (
                <div className="field">
                    <label className="label">{currentLocale.enterEmail}:</label>
                    <Field
                        className="control input"
                        validate={validateEmail}
                        name="email"
                        type="email"
                        placeholder={currentLocale.email}
                    />
                    {errors.email && touched.email && (
                        <span className="validation-message">{errors.email}</span>
                    )}
                </div>
            )}
            {waiver.getPhone && (
                <div className="field">
                    <label className="label">{currentLocale.enterPhone}:</label>
                    <Field
                        name="phoneNumber"
                        validate={(phoneNumber) =>
                            window.intlTelInputUtils.isValidNumber(phoneNumber, "")
                                ? ""
                                : `${currentLocale.phoneNumberError}`
                        }
                        component={CustomIntlTelInput}
                        value={values.phoneNumber}
                        preferredCountries={preferredCountries}
                        css="input"
                    />
                    <Field
                        className="checkbox"
                        component={Checkbox}
                        name="messagingOptIn"
                        label={currentLocale.messagingOptInHeading}
                        value={values.messagingOptIn}
                    />
                </div>
            )}
            {waiver.getAddress && (
                <div className="field">
                    <label className="label">{currentLocale.enterAddress}:</label>
                    <Field name="address">                   
                        {({ field, form }) => (
                            <AddressInput
                                name="addressInput"
                                className="control input"
                                value={field.value ? { addressText: field.value } : null}
                                onChange={(addressValue) => {
                                    form.setFieldValue("address", addressValue && addressValue.addressText ? addressValue.addressText : "");
                                }}
                                onBlur={() => form.setFieldTouched("address", true)}
                                placeholder={currentLocale.address}
                            />
                        )}
                    </Field>
                    {errors.address && touched.address && (
                        <span className="validation-message">{errors.address}</span>
                    )}
                </div>
            )}
        </>
    );
};

export default ContactInfoFields;
